import React from "react";

export default React.createContext({
    handleChange : (event :any) => {},
    language: '',
});